// import MobileMenu from './header-mobile-menu';
import { throttle } from '../util/utils';

const mastheadClass = 'masthead';
const megamenuClass = 'megamenu';

const Masthead = (() => {

	const mh = {
		element: undefined,
		modalToggle: undefined,
		navWrapper: undefined,
		modal: undefined,
		megaMenu: undefined,
		megamenuDropdown: undefined,
	}

	mh.init = function() {
		const header = document.querySelector(`.${mastheadClass}`);
		if (!header) {
			return;
		}

		mh.element = header;

		mh.setupMegamenu();

		// mh.initModal();

		// MobileMenu.init();


		// window.addEventListener('scroll', mh.autoHide);
	}

	mh.initModal = function() {

		const navModal = mh.element.querySelector(`.${mastheadClass}__nav-modal`);
		mh.modal = navModal;

		const modalToggle = document.querySelector(`.${mastheadClass}__modal-toggle`);
		mh.modalToggle = modalToggle;
		if (modalToggle) {
			modalToggle.addEventListener('click', () => {
				if (modalToggle.getAttribute('aria-expanded') === 'true') {
					mh.closeModal();
				}
				else {
					mh.openModal();
				}
			});
		}

		const menuTrigger = document.querySelectorAll('.menu-trigger');
		menuTrigger.forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				mh.closeModal();
			})
		})
	}

	mh.isMobileLayout = function() {
		const query = window.matchMedia('(max-width: 1200px)');
		return query.matches;
	}

	mh.openModal = function() {
		mh.modalToggle.setAttribute('aria-expanded', 'true');
		mh.modal.setAttribute('aria-hidden', 'false');
		document.body.classList.add('modal-active');

		window.addEventListener('keyup', mh._closeModalOnEscapeKey, {passive: true});
	}

	mh.closeModal = function() {
		mh.modalToggle.setAttribute('aria-expanded', 'false');
		mh.modal.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('modal-active');

		// MobileMenu.closeAllSubmenus();

		window.removeEventListener('keyup', mh._closeModalOnEscapeKey);
	}

	mh._closeModalOnEscapeKey = function(e) {
		if (e.key === 'Escape') {
			mh.closeModal();
		}
	}

	// move outside of object???
	mh.autoHide = throttle((e) => {

		this.lastScroll = this.lastScroll || 0; // store for next invocation
		const currentScroll = window.scrollY;
		const didScrollUp = currentScroll < this.lastScroll;

		const staticZone = 0; // header always at top of document
		const bufferZone = 0.4 * window.innerHeight; // area to allow sticky header to animate hidden
		const revealZone = 0.8 * window.innerHeight; // header can sticky autohide

		const isStaticZone = staticZone <= currentScroll && currentScroll < bufferZone;
		const isBufferZone = bufferZone <= currentScroll && currentScroll < revealZone;
		const isRevealZone = revealZone <= currentScroll;

		mh.element.classList.add(`${mastheadClass}--sticky`);
		if (isRevealZone) {
			mh.element.classList.remove(`${mastheadClass}--white`);

			if (didScrollUp) {
				// h.element.classList.remove(`${headerClass}--sticky-hidden`);
			}
			else {
				// h.element.classList.add(`${headerClass}--sticky-hidden`);
			}
		}
		else if (isBufferZone) {
			// h.element.classList.add(`${headerClass}--sticky-hidden`);
			mh.element.classList.remove(`${mastheadClass}--white`);
		}
		else { // isStaticZone
			mh.element.classList.remove(`${mastheadClass}--sticky`);
			// h.element.classList.remove(`${headerClass}--sticky-hidden`);

			if (didScrollUp) {
				mh.setHeaderColours();
			}
		}

		this.lastScroll = currentScroll;
	}, 32);


	mh.onSwupContentReplaced = function() {
		mh.setHeaderColours();
	}

	mh.setupMegamenu = function() {
		const menu = document.querySelector(`.${megamenuClass}`);
		if (!menu) {
			return;
		}

		mh.megamenu = menu;

		const dropdown = document.querySelector(`.${megamenuClass}-dropdown`);
		if (!dropdown) {
			return;
		}

		mh.megamenuDropdown = dropdown;

		const triggers = Array.from(menu.querySelectorAll('[data-megamenu-toggle]'));
		if (!triggers.length) {
			return;
		}

		triggers.forEach(trigger => {
			trigger.addEventListener('click', () => {
				const layoutName = trigger.dataset.megamenuToggle;
				const layout = dropdown.querySelector(`[data-megamenu-layout="${layoutName}"]`);
				if (!layout) {
					return;
				}

				if (dropdown.getAttribute('aria-hidden') === 'false') {
					const previous = dropdown.dataset.current;
					const isDifferentMenu = previous !== layoutName;
					if (isDifferentMenu) {
						// leave open and update the current layout
						dropdown.dataset.current = layoutName;
					}
					else {
						mh.closeMegamenu();
					}
				}
				else {
					mh.openMegamenu(layoutName);
				}

				const allLayouts = Array.from(dropdown.querySelectorAll('[data-megamenu-layout]'));
				allLayouts.forEach(layout => {
					if (layout.dataset.megamenuLayout === layoutName) {
						layout.classList.add('current');
					}
					else {
						layout.classList.remove('current');
					}
				});
			});
		})
	}

	mh.openMegamenu = function(layoutName = '') {
		const dropdown = mh.megamenuDropdown;
		if (!dropdown) {
			return;
		}

		const previous = dropdown.dataset.current;
		const isDifferentMenu = previous && previous !== layoutName;
		if (isDifferentMenu) {
			// leave open and update the current layout
			dropdown.dataset.current = layoutName;
		}
		else {
			dropdown.setAttribute('aria-hidden', 'false');
			mh.element.classList.add(`${mastheadClass}--megamenu-active`);
			dropdown.dataset.current = layoutName;
			window.addEventListener('click', mh.onClickOutsideMegamenu)
		}
	}

	mh.closeMegamenu = function() {
		const dropdown = mh.megamenuDropdown;
		if (!dropdown) {
			return;
		}

		dropdown.setAttribute('aria-hidden', 'true');
		mh.element.classList.remove(`${mastheadClass}--megamenu-active`);
		dropdown.dataset.current = '';
		window.removeEventListener('click', mh.onClickOutsideMegamenu)
	}

	mh.onClickOutsideMegamenu = function(e) {
		const clickedOutside = !e.target.closest(`.${mastheadClass}`);

		if (clickedOutside) {
			mh.closeMegamenu();
		}
	}

	return mh;
})();


export default Masthead;



// WEBPACK FOOTER //
// ./scripts/modules/masthead.js